export function removeAccents(text) {
  if (!text) return '';
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function normalizeForSearch(text) {
  return removeAccents(text).toLowerCase();
}
